module.exports = __webpack_public_path__ + "static/media/reactnative.b8c8b66a.png";